// extracted by mini-css-extract-plugin
export default {"industry":"industry_industry__nKHHc","verticalLine":"industry_verticalLine__taQgy","industryTable":"industry_industryTable__L7pjy"};